import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

export const JacksonvilleLocal = () => (
  <section className="py-20 md:py-24 bg-white" data-testid="jacksonville-local-section">
    <div className="container-custom max-w-4xl">
      <div className="inline-flex items-center gap-2 bg-[#EA580C]/10 text-[#EA580C] px-4 py-2 rounded-full text-sm font-semibold mb-6">
        <MapPin className="w-4 h-4" />
        Serving Northeast Florida
      </div>
      <h2 className="text-3xl md:text-4xl font-bold text-[#1F2937] mb-6" style={{ fontFamily: "Manrope" }} data-testid="local-h2">
        Sell Diabetic Test Strips for Cash in Jacksonville, FL
      </h2>

      <div className="space-y-5 text-lg text-[#4B5563] leading-relaxed">
        <p>
          If you live in Jacksonville, Florida — or anywhere in the surrounding metro — and you have extra, unused
          diabetic test strips gathering dust in a drawer, you don&apos;t need to mail them off to a company you have never
          heard of. Cash for Test Strips Jacksonville is a locally operated buyer of eligible diabetic supplies, and we
          work directly with sellers face to face.
        </p>

        <p>
          We regularly meet sellers in every part of town. Whether you&apos;re in{" "}
          <strong>Jacksonville Beach</strong> after a shift, coming from{" "}
          <strong>Orange Park</strong> on your way home, on a lunch break in{" "}
          <strong>Southside</strong>, or running errands through{" "}
          <strong>Mandarin</strong>, <strong>Arlington</strong>, <strong>Riverside</strong>, or{" "}
          <strong>San Marco</strong>, we&apos;ll pick a safe, public location that works for your schedule. We also serve{" "}
          <strong>Ponte Vedra</strong>, Fernandina Beach, and much of Clay and Nassau counties for people willing to
          meet at a convenient midpoint.
        </p>

        <p>
          The process is simple. Text a photo of your box to <a href="tel:+19049559646" className="text-[#0F5132] font-semibold underline hover:text-[#0B3D25]">(904) 955-9646</a>{" "}
          — front and back, so we can see the brand, product code, and expiration date. We&apos;ll review the item
          against our current requirements and let you know quickly whether it qualifies. If it does, we set up a local
          meetup at a coffee shop, grocery-store parking lot, or gas station near you.
        </p>

        <p>
          Not every box qualifies, and we&apos;d rather tell you upfront than have you drive across the bridge for
          nothing. Eligibility depends on the brand, the printed expiration date, the condition of the packaging, and a
          few other factors. Boxes marked Medicaid or Medicare are not accepted. If you want to check what we&apos;re
          currently buying before you send a photo, take a look at{" "}
          <Link to="/accepted-diabetic-supplies/" className="text-[#0F5132] font-semibold underline hover:text-[#0B3D25]">
            what supplies we accept
          </Link>{" "}
          or read the full{" "}
          <Link to="/sell-diabetic-test-strips/" className="text-[#0F5132] font-semibold underline hover:text-[#0B3D25]">
            sell diabetic test strips
          </Link>{" "}
          guide.
        </p>

        <p>
          We know a lot of people in Jacksonville have extra CGM sensors after switching from a Dexcom G6 to a G7,
          leftover Omnipod pods after moving off pump therapy, or unused test strips that came home with a family
          member. Rather than watching those hundreds of dollars of supplies expire in a cabinet, you can turn them
          into cash the same day and put them back into use for someone else who needs them.
        </p>

        <p>
          There&apos;s no shipping, no waiting on checks, no signing up on a random website. Just a text, a quick reply,
          and a local meetup. If you&apos;ve been searching for a{" "}
          <Link to="/who-buys-diabetic-supplies-near-me/" className="text-[#0F5132] font-semibold underline hover:text-[#0B3D25]">
            local buyer of diabetic supplies
          </Link>{" "}
          in Jacksonville, this is the simplest way to get started.
        </p>
      </div>
    </div>
  </section>
);
